import { useWindowSize } from 'common/hooks';

const PREVIEW_SIZE = 0.1;

export default function useLoop({ breakpoints, slidesLength, showPreview }) {
  const { width } = useWindowSize();

  const currentBreakpoint = Object.keys(breakpoints)
    .map((key) => parseInt(key))
    .sort((a, b) => b - a)
    .find((size) => width > size);

  if (!currentBreakpoint) {
    return {
      loop: slidesLength > 1,
      loopAdditionalSlides: slidesLength,
      pending: !width,
      slidesPerView: showPreview ? 1 + PREVIEW_SIZE : 1,
    };
  }

  const slidesPerView = Number(breakpoints[currentBreakpoint].slidesPerView);
  const loop = currentBreakpoint >= 0 ? slidesLength > slidesPerView : false;

  return {
    loop,
    loopAdditionalSlides: slidesLength,
    breakpoints: showPreview
      ? Object.fromEntries(
          Object.entries(breakpoints).map(([key, value]) => {
            return [
              key,
              value?.slidesPerView && slidesLength !== slidesPerView
                ? {
                    ...value,
                    slidesPerView: value.slidesPerView + PREVIEW_SIZE,
                  }
                : value,
            ];
          })
        )
      : breakpoints,
    pending: !width,
    slidesPerView:
      showPreview && slidesLength !== slidesPerView
        ? slidesPerView + PREVIEW_SIZE
        : slidesPerView,
  };
}
